module.exports = __webpack_public_path__ + "img/thedogcompany.9d864bae.png";